import React from 'react'

export default function Add16games() {
  return (
    <div className='container bg-amber-400'>
        <div className=''>
            
        </div>
    </div>
  )
}
